/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Scroll event instance dispatched by `scroll` directive
 */
export class ScrollEvent extends Event {
  /**
   * @param {string}    type    Type name of the event
   * @param {EventInit} options Event init dictionary
   * @param {object}    record  Scrolling record
   * @param {Event}     record.originalEvent The original scroll event which fires this sub event.
   * @param {string=}   record.horizontal
   * @param {number=}   record.scrollX
   * @param {string=}   record.vertical
   * @param {number=}   record.scrollY
   */
  constructor(type, options, record) {
    super(type, options);

    this.record = record;
  }
}
